import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import adBlocker from './adBlocker';
import ads from './ads';
import editableAd from './adCreation';
import auth from './auth';
import user from './user';
import targeting from './targeting';
import network from './network';
import validation from './validation';
import featureFlags from './featureFlags';
import { reducer as formReducer } from 'redux-form';
import payments from './payments';
import adminAlert from './adminAlert';
import audienceSizer from './audienceSizer';
import routes from './routes';

export default combineReducers({
  adBlocker,
  adminAlert,
  ads,
  editableAd,
  auth,
  user,
  targeting,
  network,
  validation,
  featureFlags,
  routing: routerReducer,
  form: formReducer,
  payments,
  audienceSizer,
  routes,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js